/**
 * Pure rules of the repricing pass view in DOR / LOR (CU-869fmm949). No aliases: tested with node.
 */
const joined = value => Array.isArray(value) ? value.filter(v => v != null && v !== '').join(',') : (value ?? '')

/** The query of the decisions read: the table's filters that narrow which decisions count — dates, lengths, ACRISS,
 *  Categories and ACRISS groups (UX Obs. 18, criterion 9). */
export function decisionsQuery(payload) {
	return {
		repricingExecutionID: payload.repricingExecutionID,
		officePickupID: payload.officePickupID,
		pickupDate: joined(payload.pickupDate),
		lor: joined(payload.lor),
		acriss: joined(payload.acriss),
		categoryID: joined(payload.categoryID),
		acrissGroupID: joined(payload.acrissGroupID),
		// the Cars selector above the table (CU-869fmpqfm): its cars, only when picked; several comma-joined (v1.2)
		...payload.carPickType && { carPickType: payload.carPickType, carPick: joined(payload.carPick) },
	}
}

/** What a newly opened execution starts with: the "Repricing decisions" switch on (criterion 3). Called where the
 *  analyzer resets its filters for a new execution (`resetCustomFilters`), not on every search, so switching Min /
 *  Max or searching again keeps the user's choice. */
export function resetPassView({ showPassDecisions }) {
	showPassDecisions.value = true
}
